import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { IGoogleMerchantSyncState, SLICE_NAME } from './models';

const merchantSettingsSelector = (state: RootState): IGoogleMerchantSyncState => state[SLICE_NAME];

export const selectGoogleMerchantSyncRuns = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSyncState) => state.syncRuns,
);

export const selectGoogleMerchantSyncRunsPagination = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSyncState) => state.pagination,
);

export const selectGoogleMerchantSyncIsLoading = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSyncState) => state.isLoading,
);

export const selectGoogleMerchantSyncError = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSyncState) => state.error,
);
